import * as React from "react";

export const IconConvert = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clip-path="url(#clip0_32766_20378)">
      <path
        d="M17.66 9.53078L10.59 16.6008L6.35 12.3608L7.76 10.9508L10.59 13.7808L16.25 8.12078L17.66 9.53078ZM4 12.0008C4 9.67078 5.02 7.58078 6.62 6.12078L9 8.50078V2.50078H3L5.2 4.70078C3.24 6.52078 2 9.11078 2 12.0008C2 17.1908 5.95 21.4508 11 21.9508V19.9308C7.06 19.4408 4 16.0708 4 12.0008ZM22 12.0008C22 6.81078 18.05 2.55078 13 2.05078V4.07078C16.94 4.56078 20 7.93078 20 12.0008C20 14.3308 18.98 16.4208 17.38 17.8808L15 15.5008V21.5008H21L18.8 19.3008C20.76 17.4808 22 14.8908 22 12.0008Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_32766_20378">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
